module.exports = __webpack_public_path__ + "static/media/GeneralColumbia.f0b50b99.webp";